import { atom } from 'jotai';

export const pendoApiKeyAtom = atom<string | null>(null);
